import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface countryInterface {
    code: string
    name: string
}

export interface subdivisionInterface {
    abbreviation: string
    name: string
}

export default (axios: AxiosInstance = baseAxios): { fetchCountries: () => Promise<countryInterface[]>; fetchSubdivisions: (countryCode: string) => Promise<subdivisionInterface[]>; } => ({
    fetchCountries: async (): Promise<countryInterface[]> => {
        const response = await axios.get<countryInterface[]>('/api/addresses/countries');

        return response.data;
    },

    fetchSubdivisions: async (countryCode: string): Promise<subdivisionInterface[]> => {
        const response = await axios.get<subdivisionInterface[]>(`/api/addresses/countries/${countryCode}/subdivisions`);

        return response.data;
    },
});
